import React from 'react';
import classes from '../InviteFriend.module.scss';

export default <div className={classes.infoContainer}>
  <h1>
    მიიღე საჩუქრად 10 ლარის ღირებულების <mark>50 FREESPIN</mark> სლოტში -{' '}
    <mark>20 Burning Hot</mark>
    <br />
    <span style={{ display: 'block', marginTop: '1rem' }}>
        ყველა მოწვეულ და ვერიფიცირებულ მეგობარზე
      </span>
  </h1>
  <section>
    <h2>რეგისტრაცია</h2>
    <p>1. ავტორიზაციის შემდეგ, შენს ანგარიშში დააჭირე ღილაკს - მოიწვიე</p>
    <p>
      2. შეიყვანე იმ პიროვნების მობილური და პირადი ნომერი, რომლის მოწვევაც
      გსურს და დააჭირე ღილაკს - გაგრძელება
    </p>
    <p>
      3. მითითებულ მობილურზე გამოიგზავნება SMS კოდი. შეიყვანე კოდი შესაბამის
      ველში და დააჭირე ღილაკს - დადასტურება
    </p>
    <p>
      4. ნომრის შემოწმების შემდეგ, შეიყვანე მეგობრის ელ.ფოსტა და მომხმარებლის
      სახელი(username), წაიკითხე და მონიშნე აუცილებელი ველი და დააჭირე ღილაკს
      - დასრულება
    </p>
  </section>
  <section>
    <h2>ვერიფიკაცია</h2>
    <p>
      5. რეგისტრაციის პროცესი დასრულების შემდეგ, დაელოდე მეგობარს, რომ
      ატვირთოს დოკუმენტები და გაიაროს ვერიფიკაცია ან თუ გსურს, თავად გაატარო
      მას ვერიფიკაცია, დააჭირე ღილაკს - დოკუმენტების ატვირთვა
    </p>
    <p>
      6. აირჩიე პირადობის მოწმობა ან პასპორტი, ატვირთე მეგობრის დოკუმენტის
      ორივე მხარე, მისი სელფი და დააჭირე ღილაკს - დოკუმენტების ატვირთვა
    </p>
    <p>
      7. ვერიფიკაციისთვის დოკუმენტები ატვირთულია, სიაში შეგიძლია თვალი ადევნო
      მოწვეული მეგობრების სტატუსს.
    </p>
  </section>
  <section>
    <h2>როგორ შევამოწმო მეგობრის სტატუსი?</h2>
    <p>
      მოწვეული მეგობრების სიაში, სტატუსის ველში გამოჩნდება რა ეტაპზეა
      ვერიფიკაციის პროცესი:
    </p>
    <p>
      ვერიფიკაცია - ვერიფიკაციის პროცესი არ დაწყებულა. ღილაკზე დაჭერით
      შესაძლებელია დოკუმენტების ატვირთვა და ვერიფიკაციის დაწყება.
    </p>
    <p>
      განახლება - ვერიფიკაცია შეჩერებულია და საჭიროა ხარვეზიანი დოკუმენტის
      თავიდან ატვირთვა.
    </p>
    <p>
      უარყოფილი - ინფორმაცია შემოწმებულია და მომხმარებელმა ვერ გაიარა
      ვერიფიკაცია.
    </p>
    <p>
      დასრულებული - თუ ველი გამწვანებულია, ვერიფიკაციის პროცესი წარმატებით
      დასრულდა და მალე გაგიაქტიურდება საჩუქარი - <mark>50 FREESPIN</mark>.
    </p>
    <br />
    <p>
      გაიაქტიურე დამატებითი საჩუქრები სლოტში - <mark>20 Burning Hot</mark>,
      10, 30 და 50 მომხმარებლის დარეგისტრირების შემდეგ:
    </p>
    <ul>
      <li>
        10 მეგობარი: <mark>+100 FREESPIN</mark>
      </li>
      <li>
        30 მეგობარი: <mark>+300 FREESPIN</mark>
      </li>
      <li>
        50 მეგობარი: <mark>+500 FREESPIN</mark>
      </li>
    </ul>
    <p>
      საჩუქრები დაგერიცხება ვერიფიკაციის დასრულებიდან 30 წუთის განმავლობაში.
    </p>
  </section>
</div>